import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../../../../components/header";
import { useIntl } from "react-intl";
import Skeleton from "../../../../components/skeleton";
import PackageTracing from "../fragments/package-tracking";
import { fetchGetTrackById } from "../../../../../../../api";
import { useQuery } from "../../../../../../hooks/common";
import { useState } from "react";
import { fetchUnifiedProcessing } from "../../../../utils";


const OrderSubPackageTrack = props =>{
    useStyles(cls);
    const Intl = useIntl();
    const query = useQuery();
    const [parcelPackage, setParcelPackage] = useState(null);

    useEffect(async () =>{
        let response = await fetchGetTrackById({ type: query?.type, id: query?.packageId });
        setParcelPackage(fetchUnifiedProcessing(response));
    }, []);

    return <div className={cls.OrderSubPackageTrack}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "logisticsInfo", defaultMessage: "Logistics Information" })} 
        />

        {
            parcelPackage ? <PackageTracing parcelPackage={parcelPackage} isSub /> : <Skeleton />
        }
    </div>
}

export default OrderSubPackageTrack;